/* movimiento.js · /diseno-web · v2.1 (2026-10-18)
   v2.1 (2026-10-18) — motivo: convivir con movimiento-pro.js (referencias/holo-movimiento.md): no toca
     nada que esté dentro de un módulo [data-mp] (lo anima el otro script) para que no haya doble animación.
   v2 (2026-10-17) — motivo: tema «Premium fluido» (referencias/rayyan-web-negocio-premium.md):
     · el escalonado entre hermanos se lee del token CSS --rv-paso (ms; 60 si el tema no lo define),
     · nuevas piezas que aparecen: .escena > *, .recorrido, .etiqueta, .hechos li,
     · scroll suave OPCIONAL con Lenis 1.3.4 (jsDelivr, versión fija) solo si <html data-scroll="suave">,
       con ratón/trackpad (en táctil, scroll nativo), y nunca con prefers-reduced-motion.
   v1: aparición suave al hacer scroll (fade-up) para páginas con la estructura de landing-base.html.
   - Sin dependencias obligatorias. Se carga con <script src="movimiento.js" defer></script>.
   - Nunca anima el hero (es el LCP) ni nada que ya esté en pantalla al cargar.
   - Con prefers-reduced-motion, o sin IntersectionObserver, todo se ve al instante.
   - Compatible con los 4 temas: cada tema decide CÓMO se ven .rv y .rv.in. */
(function () {
  var d = document, raiz = d.documentElement;
  var reducir = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducir) return;

  /* ---- 1 · Scroll suave opcional (Lenis, solo ratón/trackpad) ---- */
  var punteroFino = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (raiz.getAttribute('data-scroll') === 'suave' && punteroFino) {
    var s = d.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.3.4/dist/lenis.min.js';
    s.async = true;
    s.onload = function () {
      if (!window.Lenis) return;
      raiz.style.scrollBehavior = 'auto'; // el scroll-behavior:smooth de la base choca con Lenis
      var estilo = d.createElement('style');
      estilo.textContent = 'html.lenis,html.lenis body{height:auto}.lenis.lenis-stopped{overflow:clip}.lenis.lenis-smooth iframe{pointer-events:none}';
      d.head.appendChild(estilo);
      var lenis = new window.Lenis({ lerp: 0.1, smoothWheel: true, syncTouch: false, autoRaf: true,
        prevent: function (n) { return !!(n.closest && n.closest('dialog,[data-lenis-prevent]')); } });
      window.lenisPagina = lenis;
      // Enlaces internos (#comprar, #demo…) con el mismo deslizamiento
      d.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href^="#"]');
        if (!a || e.defaultPrevented || a.getAttribute('href').length < 2) return;
        // (2026-10-17, auditoría de errores · código — motivo: un href como «#/2:1,5:1?…» (carrito de la demo) no es un
        // selector válido y querySelector lanzaba un error sin capturar en consola)
        var destino = null;
        try { destino = d.querySelector(a.getAttribute('href')); } catch (err) { return; }
        if (!destino) return;
        e.preventDefault();
        lenis.scrollTo(destino, { offset: -12, duration: 1.1 });
      });
    };
    d.head.appendChild(s);
  }

  /* ---- 2 · Aparición al entrar en pantalla ---- */
  if (!('IntersectionObserver' in window)) return;
  var paso = parseInt(getComputedStyle(raiz).getPropertyValue('--rv-paso'), 10) || 60;
  var selector = [
    'main section:not(.hero) h2', '.giro', '.dolores li', '.pasos li', '.esquema',
    '.galeria figure', '.muestra', '.quien > div', '.grupo', '.contexto',
    '.opinion', '.hueco', '.autor', '.bono', '.garantia', '.planes', '.bumps', 'details',
    '.escena > *', '.recorrido', 'section:not(.hero) .etiqueta', '.hechos li'
  ].join(',');
  var els = Array.prototype.slice.call(d.querySelectorAll(selector));
  var alto = window.innerHeight;
  els = els.filter(function (el) { return !el.closest('.hero') && !el.closest('[data-mp]') && el.getBoundingClientRect().top > alto * 0.9; });
  if (!els.length) return;
  raiz.classList.add('js');
  els.forEach(function (el) {
    el.classList.add('rv');
    var hermanos = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
    el.style.setProperty('--rv-retraso', Math.min(hermanos, 5) * paso + 'ms');
  });
  var io = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  // Los titulares pueden ocultarse con clip-path (tema Premium): un elemento recortado a 0 px no
  // «intersecta», así que se vigila a su contenedor y se le pasa la clase al titular.
  var ioTit = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target._titulares.forEach(function (h) { h.classList.add('in'); }); ioTit.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
  els.forEach(function (el) {
    if (el.tagName === 'H2' && el.parentElement) {
      var p = el.parentElement;
      (p._titulares = p._titulares || []).push(el);
      ioTit.observe(p);
    } else { io.observe(el); }
  });
})();
